module.exports = __webpack_public_path__ + "static/media/Print-Belaych-2.cf176bdc.jpg";